import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getSitePR, { SitePRResponse } from "../http/getSitePR";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSitePR = (siteId: string) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const prQuery: UseQueryResult<SitePRResponse, unknown> = useQuery(
    ["site", siteId, "health_pr"],
    async () => {
      return getSitePR(await getAuthTokenBlocking(getToken, relogin), siteId);
    },
    {
      staleTime: 5 * 60 * 1000,
    }
  );

  return { prQuery };
};

export default useSitePR;
